import React, {
    useState
}
from "react";

import {
    FontAwesomeIcon
}
from "@fortawesome/react-fontawesome";

import {
    faSearch
}
from "@fortawesome/free-solid-svg-icons";


//========================================================
// Snippet Search Bar
//========================================================

export default function SnippetSearchBar({
    onSearch,
    loading
})
{
    const [value, setValue] =
        useState("");


    //========================================================
    // Submit
    //========================================================

    const submit = (event) =>
    {
        event.preventDefault();

        if (!value.trim())
        {
            return;
        }

        onSearch(
            value.trim()
        );
    };


    //========================================================
    // Render
    //========================================================

    return (
        <form
            onSubmit={submit}
            style={styles.container}
        >
            <FontAwesomeIcon
                icon={faSearch}
                style={styles.icon}
            />

            <input
                value={value}
                onChange={
                    event =>
                        setValue(
                            event.target.value
                        )
                }
                placeholder="Search documents and snippets..."
                style={styles.input}
            />

            <button
                type="submit"
                disabled={loading}
                style={styles.button}
            >
                {
                    loading
                        ? "Searching..."
                        : "Search"
                }
            </button>
        </form>
    );
}


//========================================================
// Styles
//========================================================

const styles =
{
    container:
    {
        display: "flex",
        alignItems: "center",
        width: "100%",
        maxWidth: "900px",
        height: "56px",
        background: "#ffffff",
        border:
            "1px solid rgba(38,55,70,0.12)",
        borderRadius: "8px",
        boxShadow:
            "0 8px 24px rgba(38,55,70,0.08)",
        overflow: "hidden"
    },

    icon:
    {
        marginLeft: "20px",
        color: "#7b8791",
        fontSize: "16px"
    },

    input:
    {
        flex: 1,
        height: "100%",
        border: "none",
        outline: "none",
        padding: "0 18px",
        fontSize: "15px",
        color: "#263746",
        background: "transparent"
    },

    button:
    {
        height: "40px",
        marginRight: "8px",
        padding: "0 22px",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: 600
    }
};